import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { beneVerifyThisGST } from "../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

export const useGstVerification = (gstin, pan) => {
  const dispatch = useDispatch();
  const [GSTStatus, setGSTStatus] = useState(null);
  const [GSTLinked, setGSTLinked] = useState(false);
  const [gstVerified, setGstVerified] = useState(false);

  const { beneVerifyGST, isGSTLoading } = useSelector(
    (state) => state.beneAllVerification,
  );

  const apiStatus = beneVerifyGST?.status ?? null;
  const apiError = beneVerifyGST?.errors ?? null;
  const details = beneVerifyGST?.gstin_details ?? null;

  const isValidFormat = gstin?.length === GlobalConfiguration?.gstLength;

  const isLinked = useMemo(() => {
    if (!isValidFormat || !pan) return null;

    const gstPan = gstin.substring(2, 12).toUpperCase();
    const currentPan = pan.toUpperCase();

    return gstPan === currentPan;
  }, [gstin, pan, isValidFormat]);

  const isValid = useMemo(() => {
    if (!isValidFormat) return null;
    return apiStatus === true && !apiError;
  }, [apiStatus, apiError, isValidFormat]);

  const isVerified = useMemo(() => {
    if (!isValidFormat) return null;

    if (apiStatus === true && !apiError) return true;
    if (apiStatus === false || apiError) return false;

    return null;
  }, [apiStatus, apiError, isValidFormat]);

  useEffect(() => {
    if (gstin?.length === GlobalConfiguration?.gstLength) {
      dispatch(beneVerifyThisGST({ search_string: gstin }));
    }
  }, [gstin, dispatch]);

  useEffect(() => {
    if (gstin?.length === GlobalConfiguration?.gstLength) {
      let linkedCheck = gstin.substring(
        GlobalConfiguration?.lengthCheckTwo,
        gstin.length - GlobalConfiguration?.lengthCheckThree,
      );

      if (linkedCheck === pan && beneVerifyGST?.status === true) {
        setGSTStatus(true);
        setGstVerified(true);
        setGSTLinked(true);
      } else {
        setGSTStatus(false);
        setGstVerified(false);

        if (linkedCheck !== pan && beneVerifyGST?.status === true) {
          setGSTLinked(false);
        }
      }
    } else {
      setGSTStatus(null);
      setGstVerified(false);
      setGSTLinked(false);
    }
  }, [gstin, pan, beneVerifyGST]);

  return {
    loading: isGSTLoading,
    status: apiStatus,
    error: apiError,
    details,
    isValid,
    isLinked,
    isVerified,
    isValidFormat,
    GSTStatus,
    gstVerified,
    GSTLinked,
  };
};
